<template>
  <section class="hero">
  <div class="hero-body">
    <div class="container">
        <div class="columns is-centered is-vcentered">
            <div class="column is-4">
                <b-field label="Vul hieronder de enquête code in (5 tekens):">
                    <b-input class="text-input shortlink-input" v-model="shortlink" required></b-input>
                </b-field>
                <a :href="'https://enquete.acc.prestatiedatabank.nl/' + shortlink" class="button has-text-weight-bold is-rounded start-button" @click="go()">Naar formulier</a>
            </div>            
        </div>
      
    </div>
  </div>
</section>

 
</template>

<script>
export default {
    data () {
        return {
            shortlink: ''
        }
    },
    methods: {
        go: function () {

        }
    }
}
</script>

<style scoped>

.input .shortlink-input {
    width: 100% !important;
    
}

</style>


// WEBPACK FOOTER //
// src/components/elements/intro/NoSurvey.vue